export default "__VITE_ASSET__7a4321c4__"